import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";

export const quizUserResponseToQuestionsModal = {
  label: "Quiz Report",
  path: (tenantName) => `/${tenantName}/reports/quizReport`,

  columns: (navigate) => [
    {
      ID: 1,
      name: "User",
      fieldName: "UserName",
      value: (row) => row.UserName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: "Response",
      fieldName: "UserSelectedChoice",
      value: (row) => row.UserSelectedChoice,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
  ],
};
